import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';

const InquiryWrite = () => {
  const navigate = useNavigate();
  const { board_seq } = useParams();

  const [inquiryDate, setInquiryDate] = useState("");
  const [inquiryTitleList, setInquiryTitleList] = useState([]);

  const [category, setCategory] = useState("결제문의");
  const [id, setId] = useState("");
  // const [nickname, setNickname] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [answer, setAnswer] = useState("");

  const getInquiryTitleInfo = () => {
    let params = {};

    const successHandler = (response) => {
      if (response.messageCode === 200) {
        setInquiryTitleList(response.data.data_list);
      } else {
        console.log("문의 유형정보를 불러올 수 없습니다.");
        toast.error("문의 유형정보를 불러올 수 없습니다.");
      }
    };
    const failHandler = (error) => {
      console.log(error);
    };

    request.get("/common/code/board_title_ty", params, successHandler, failHandler);
  };

  useEffect(() => {
    if (board_seq) {
      const fetchInquiryData = async () => {
        try {
          const successHandler = (response) => {
            const data = response.data;
            setInquiryDate(data.reg_dtm);
            setCategory(data.board_cate || "결제문의");
            setId(data.owner_seq_al_user?.user_id || "");
            // setNickname(data.user_nickname || "");
            setTitle(data.board_title);
            setContent(data.board_content);
            setAnswer(data.board_content2 || "");
          };

          const errorHandler = (error) => {
            toast.error("문의 불러오기 중 오류가 발생했습니다.");
          };

          await request.get(`/board/list/admin/BD_INQUIRY/${board_seq}`, {}, successHandler, errorHandler);
        } catch (error) {
          toast.error("문의 불러오기 중 오류가 발생했습니다.");
        }
      };
      getInquiryTitleInfo();
      fetchInquiryData();
    }
  }, [board_seq]);

  // const handleCategoryChange = (e) => setCategory(e.target.value);
  // const handleTitleChange = (e) => setTitle(e.target.value);
  // const handleContentChange = (e) => setContent(e.target.value);
  const handleAnswerChange = (e) => setAnswer(e.target.value);

  const handleSubmit = async () => {
    const formData = {
      // board_title: title,
      // board_content: content,
      // board_cate: category,
      board_content2: answer
    };

    try {
      const successHandler = (response) => {
        console.log('문의 답변등록 response', response)
        if (response.messageCode === 200) {
          toast.success(`문의가 성공적으로 ${board_seq ? "수정" : "등록"}되었습니다.`);
          navigate("/Manage/Inquiry");
        } else {
          toast.error(`문의 ${board_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
        }
      };

      const errorHandler = (error) => {
        toast.error(`문의 ${board_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
      };

      if (board_seq) {
        await request.put(`/board/BD_INQUIRY/${board_seq}`, formData, successHandler, errorHandler);
      } else {
        await request.post("/board/BD_INQUIRY", formData, successHandler, errorHandler);
      }

    } catch (error) {
      toast.error(`문의 ${board_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
    }
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">문의 {board_seq ? "수정" : "등록"}</h2>
      <div className="adm_com_pg_content">
        <table className='adm_com_board_list type_row'>
          <colgroup>
            <col width="10%" /><col />
            <col width="10%" /><col />
          </colgroup>
          <tbody>
            <tr>
              <th>등록일</th>
              <td colSpan={3}>{inquiryDate || "YYYY-MM-DD"}</td>
            </tr>
            <tr>
              <th>작성자</th>
              <td>
                {id}
              </td>
              {/* <th>닉네임</th>
              <td>
                {nickname}
              </td> */}
            </tr>
            <tr>
              <th>분류</th>
              <td colSpan={3}>
                {/* <select className="select ws" value={category} onChange={handleCategoryChange}>
                  <option value="결제문의">결제문의</option>
                  <option value="서비스문의">서비스문의</option>
                  <option value="기타문의">기타문의</option>
                </select> */}
                {/* {category} */}
                {inquiryTitleList.length > 0 && inquiryTitleList.find(a => a.comm_code === category)
                  ? inquiryTitleList.find(a => a.comm_code === category).code_nm
                  : ''}
              </td>
            </tr>
            
            <tr>
              <th>제목</th>
              <td colSpan={3}>{title}</td>
            </tr>
            <tr>
              <th>문의내용</th>
              <td colSpan={3}>{content}</td>
            </tr>
            <tr>
              <th>답변</th>
              <td colSpan={3}>
                <textarea className="textarea" value={answer} onChange={handleAnswerChange}></textarea>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="adm_com_btn_wrap center">
          <button className="adm_com_btn blue" onClick={handleSubmit}>{board_seq ? "수정" : "등록"}</button>
          <button className="adm_com_btn gray" onClick={() => navigate("/Manage/Inquiry")}>취소</button>
        </div>
      </div>
      <ToastContainer />
    </main>
  );
};

export default InquiryWrite;
